export const PATHPREFIX = process.env.GATSBY_VERCEL_ENV === 'production' ? 'https://www.prisma.io/blog' : ''
let absolutePattern = /^https?:\/\//i;

export const assignPrefix = (url: string) => {
  return absolutePattern.test(url) ? url : PATHPREFIX + url
}

export const pathsForUTMOverride = ['https://console.prisma.io']
